import _ from "lodash"

/** Today as d/m/yyyy, the format the receipt and fee endpoints expect. */
export const todayString = () => {
    const today = new Date()
    return `${today.getDate()}/${today.getMonth() + 1}/${today.getFullYear()}`
}

export const sortByRollNo = (students) =>
    [...students].sort((a, b) => Number(a.roll_no) - Number(b.roll_no))

export const initials = (name) =>
    String(name || "")
        .trim()
        .split(/\s+/)
        .filter(Boolean)
        .map((part) => part.charAt(0).toUpperCase())
        .join("")
        .slice(0, 2) || "?"

export const contactOf = (student) =>
    _.get(student, "meta_data.studentPhone") ||
    _.get(student, "meta_data.parentPhone") ||
    _.get(student, "meta_data.contact") ||
    ""

export const matchesSearch = (student, search) => {
    const term = search.trim().toLowerCase()
    if (!term) return true

    return [student?.name, student?.roll_no, student?.email]
        .some((value) => String(value ?? "").toLowerCase().includes(term))
}

/*
 * The download endpoint builds the spreadsheet from these exact keys, so they
 * must not change.
 */
export const toDownloadRows = (students) =>
    students.map((student, index) => ({
        SL_NO: index + 1,
        Name: student.name,
        Roll_No: student.roll_no,
        DOB: student.dob || "NOT PROVIDED",
        Father_Name: student.father_name || "NOT PROVIDED",
        Mother_Name: student.mother_name || "NOT PROVIDED"
    }))

/** A class student mapped onto the Add/Edit Student form's fields. */
export const toFormFields = (student) => {
    const [firstName = "", ...rest] = String(student?.name || "").trim().split(/\s+/)
    const meta = student?.meta_data || {}

    return {
        firstName,
        lastName: rest.join(" "),
        gender: meta.gender,
        dob: student?.dob,
        bloodGroup: meta.bloodGroup,
        studentEmail: student?.email,
        studentPhone: meta.studentPhone,
        address: meta.Address,
        admissionNumber: meta.admissionNumber,
        rollNumber: student?.roll_no,
        section: meta.section,
        academicYear: meta.academicYear,
        fatherName: student?.father_name,
        motherName: student?.mother_name,
        fatherOccupation: meta.fatherOccupation,
        motherOccupation: meta.motherOccupation,
        parentPhone: meta.parentPhone,
        emergencyContact_1: meta.emergencyContact_1,
        emergencyContact_2: meta.emergencyContact_2
    }
}

/** Saves a downloaded Blob under `filename`. */
export const saveBlob = (blob, filename) => {
    const url = window.URL.createObjectURL(blob)
    const link = document.createElement("a")
    link.href = url
    link.download = filename
    document.body.appendChild(link)
    link.click()
    link.remove()
    window.URL.revokeObjectURL(url)
}
